@if (initialized && objectLoaded && dto) {

    @if (uiMode == 'side') {

        <te-template-object-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></te-template-object-side>
    } @else {

        <te-template-object-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></te-template-object-full>
    }


} @else {
    <!-- Skeleton loading state while template data is being fetched -->
    <div class="px-3 py-2 surface-section border-round shadow-1 mb-3 mt-3">
        <div class="flex align-items-center gap-3">
            <p-skeleton width="2rem" height="2rem" borderRadius="50%"></p-skeleton>
            <p-skeleton width="15rem" height="1.5rem"></p-skeleton>
        </div>
    </div>
    <div class="surface-ground mt-3" style="height: calc(100vh - 120px);">
        <div class="flex gap-3 h-full">
            <div class="surface-section border-round shadow-1 p-3" style="width: 30%;">
                <p-skeleton width="8rem" height="1rem" styleClass="mb-3"></p-skeleton>
                <p-skeleton width="100%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="90%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="80%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="95%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="70%" height="1.5rem" styleClass="mb-2"></p-skeleton>
            </div>
            <div class="surface-section border-round shadow-1 p-3 flex-1">
                <p-skeleton width="100%" height="2.5rem" styleClass="mb-3"></p-skeleton>
                <p-skeleton width="100%" height="calc(100% - 4rem)"></p-skeleton>
            </div>
        </div>
    </div>
}